/**
 * Public URL path for the IES logo (Vite serves files from `public/` at site root).
 * @see {@link IES_OFFICIAL_URL}
 */
export const IES_LOGO_SRC = '/logo/Logo-IES.jpg' as const;

/** Official Institute website (Viện Các Khoa học Trái đất). */
export const IES_OFFICIAL_URL = 'https://ies.vast.gov.vn/' as const;
